// extracted by css-extract-rspack-plugin
export default {"panel":"k3eyXFEIHLIZo2Zh","logo":"XTPomEy6n0urxs1_","heading":"DLlX9jDYiK8vv9G8","copy":"iWvkDjC7LUPJvt42"};